import { createAsyncThunk } from "@reduxjs/toolkit";
import eventServices from "../../services/eventServices";
import { showLoading,closeLoading,showError,showLinearLoader,closeLinearLoader } from "../slices/commonSlice";
import { setEventType } from "../slices/eventSlice";
export const getEventList=createAsyncThunk(
    "event/list",
    async(payload,thunkApi)=>{
    try{
        thunkApi.dispatch(setEventType(payload));
        thunkApi.dispatch(showLoading());
        let response=await eventServices.getEventList(payload, thunkApi.signal);
        thunkApi.dispatch(closeLoading());
        return response.data;
    }catch(error){
        thunkApi.dispatch(closeLoading());
        // The request was cancelled because a newer one superseded it (e.g. the
        // user clicked another filter). This is expected — don't surface an error.
        if(thunkApi.signal.aborted || error.name === 'CanceledError' || error.name === 'AbortError'){
            return thunkApi.rejectWithValue('aborted');
        }
        thunkApi.dispatch(showError(error.response?.data?.message || 'Something went wrong'));
        return thunkApi.rejectWithValue(error.response?.data?.message);
      }
    }
);

export const getEventDetails=createAsyncThunk(
    "event/getDetails",
    async(payload,thunkApi)=>{
    try{
        thunkApi.dispatch(setEventType(payload));
        thunkApi.dispatch(showLoading());
        let response=await eventServices.getEventDetails(payload);
        thunkApi.dispatch(closeLoading());
        return response.data.result;
    }catch(error){
        thunkApi.dispatch(closeLoading());
        thunkApi.dispatch(showError(error.response.data.message));
        return thunkApi.rejectWithValue(error.response.data.message);
      }
    }
);

export const eventBooking=createAsyncThunk(
    "event/booking",
    async(payload,thunkApi)=>{
    try{
        thunkApi.dispatch(setEventType(payload));
        thunkApi.dispatch(showLoading());
        let response=await eventServices.eventBooking(payload);
        thunkApi.dispatch(closeLoading());
        return response.data;
    }catch(error){
        thunkApi.dispatch(closeLoading());
        thunkApi.dispatch(showError(error.response.data.message));
        return thunkApi.rejectWithValue(error.response.data.message);
      }
    }
);

export const getCountryList=createAsyncThunk(
    "getCountryList",
    async(_,thunkApi)=>{
    try{
        let response=await eventServices.getCountryList();
        // NOTE: do NOT dispatch closeLoading() here. This thunk never calls
        // showLoading(), but common.loading is reference-counted — so a stray
        // closeLoading() decrements the counter that a CONCURRENT getEventDetails
        // incremented, flipping loading=false while the event is still fetching.
        // That blanked the details page on first (uncached) load. Leave the
        // shared counter alone; getEventDetails owns its own loading now.
        return response.data;
    }catch(error){
        thunkApi.dispatch(showError(error.response.data.message));
        return thunkApi.rejectWithValue(error.response.data.message);
      }
    },
    {
        // Dedup: skip the request when the country/fee list is already loaded
        // or a fetch is in flight. createAsyncThunk runs this synchronously
        // BEFORE dispatching `pending`, and `pending` flips countryListLoading
        // true — so when several components dispatch in the same render flush,
        // only the first proceeds and the rest abort. Prevents the ~7 duplicate
        // CountryList requests on the details page.
        condition:(_,{getState})=>{
            const state=getState().event;
            const data=state.getCountryFeeListDetails;
            if(Array.isArray(data) && data.length>0) return false; // already have it
            if(state.countryListLoading) return false;             // already fetching
            return true;
        }
    }
);

export const getGlobalCountry = createAsyncThunk(
    "getGlobalCountry",
    async(_,thunkApi) => {
        return payload;
    }
);


